import React from 'react';
import { FileText, Users } from 'lucide-react';
import styles from './ProfessorWelcome.module.css';

function InfoCards() {
  return (
    <div className={styles.infoGrid}>
      <div className={styles.gridContainer}>
        <div className={styles.infoCard}>
          <h3 className={styles.infoCardTitle}>
            <FileText className="w-5 h-5 mr-2" />
            Create Positions
          </h3>
          <p className={styles.infoCardDescription}>
            Post research opportunities, set requirements, and specify the skills you're looking for in candidates.
          </p>
          <ul className={styles.infoList}>
            <li className={styles.infoListItem}>• Define project scope and duration</li>
            <li className={styles.infoListItem}>• Set academic requirements</li>
            <li className={styles.infoListItem}>• Specify required skills and experience</li>
          </ul>
        </div>
        <div className={styles.infoCard}>
          <h3 className={styles.infoCardTitle}>
            <Users className="w-5 h-5 mr-2" />
            Review Applications
          </h3>
          <p className={styles.infoCardDescription}>
            Review student profiles, analyze their research interests, and assess their qualifications.
          </p>
          <ul className={styles.infoList}>
            <li className={styles.infoListItem}>• AI-powered candidate matching</li>
            <li className={styles.infoListItem}>• Comprehensive student profiles</li>
            <li className={styles.infoListItem}>• Academic transcript analysis</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default InfoCards;